var secHeaderJs = (function() {
  function init() {
    /**
    * Check if secondary nav exists then only call this function
    */
    if (document.getElementById("secondary-nav")) {
      uiBindings();
    }
  }
  var uiBindings = function() {
    var secNavMobileDropdown = document.getElementById(
      "features-dropdown-toggle"
    );
    secNavMobileDropdown.addEventListener("click", secNavMobileDropdownFn);
    var secNavMobileDropdownItems = document
      .getElementById("secondary-nav__features")
      .getElementsByTagName("a");
    for (var i = 0; i < secNavMobileDropdownItems.length; i++) {
      if (!secNavMobileDropdownItems[i].parentElement.classList.contains("custom-nested-secondary-nav")) {
        secNavMobileDropdownItems[i].addEventListener(
          "click",
          secNavMobileDropdownItemsFn
        );
      }
    }
    function secNavMobileDropdownFn(e) {
      e.preventDefault();
      e.stopPropagation();
      document
        .getElementById("secondary-nav__features")
        .classList.toggle("dd-toggle");
      this.classList.toggle("active");
      if (nestedSecondaryMenuList) {
        nestedSecondaryMenuList.classList.remove("is-toggle");
      }
    }

    function secNavMobileDropdownItemsFn() {
      document
        .getElementById("secondary-nav__features")
        .classList.toggle("dd-toggle");
      secNavMobileDropdown.classList.toggle("active");
      if (nestedSecondaryMenuList) {
        nestedSecondaryMenuList.classList.remove("is-toggle");
      }
    }
    
    /**
    * Nested Secondary sub menu Hover Effects
    */
    var nestedSecondaryMenuList = document.getElementsByClassName("custom-nested-secondary-nav")[0],
      secMenuFlag = 1;
    if (nestedSecondaryMenuList) {
      var nestedSecondaryMenuDD = nestedSecondaryMenuList.getElementsByTagName("ul")[0],
        nestedSecondaryMenuItem = nestedSecondaryMenuDD.previousElementSibling,
        nestedSecondaryToggleList = nestedSecondaryMenuDD.getElementsByTagName("li");

      nestedSecondaryMenuList.parentNode.classList.add('secondary-nav__nested-menu');
      nestedSecondaryMenuItem.setAttribute('aria-expanded', false);
      nestedSecondaryMenuItem.setAttribute('aria-haspopup', true);
      nestedSecondaryMenuItem.setAttribute('data-target', 'secondary-nested-submenu');
      nestedSecondaryMenuItem.setAttribute('href', 'javascript:void(0)');

      // prevent default action of anchor
      nestedSecondaryMenuItem.addEventListener("click", function(event) {
        event.preventDefault();
      });

      // set role menuitem to list
      for (var j = 0; j < nestedSecondaryToggleList.length; j++) {
        nestedSecondaryToggleList[j].setAttribute('role', 'menuitem');
      }

      function nestedSecondaryMenuToggleFn() {
        if (window.innerWidth <= 979) {
          if (secMenuFlag) {
            nestedSecondaryMenuList.addEventListener("click", fnToggleSecondaryMenu, true);
            secMenuFlag = 0;
          }
        } else if (window.innerWidth > 979 && (window.orientation === 90 || window.orientation === -90)) {
          // check landscape mode for ipad to remove event listener on resize
          nestedSecondaryMenuList.removeEventListener('click', fnToggleSecondaryMenu, true);
          secMenuFlag = 1;
        }
      }

      nestedSecondaryMenuToggleFn();

      nestedSecondaryMenuList.addEventListener("focusout", function(event) {
        if (!this.contains(event.relatedTarget)) {
          if (this.classList.contains("custom-nested-secondary-nav")) {
            closeSecondaryDD(nestedSecondaryMenuDD, nestedSecondaryMenuItem);
          }
        }
      });

      nestedSecondaryMenuList.addEventListener('keydown', function(event) {
        // on space and enter key press trigger keyboard events
        if (event.keyCode === 32 || event.keyCode === 13 || event.key === 'Enter') {
          if (this.classList.contains("custom-nested-secondary-nav") && event.target.parentElement === nestedSecondaryMenuList) {
            event.preventDefault();
            openSecondaryDD(nestedSecondaryMenuDD, nestedSecondaryMenuItem);
          }
        }
        if (event.key === 'Escape' || event.keyCode === 27) {
          if (this.classList.contains("custom-nested-secondary-nav")) {
            closeSecondaryDD(nestedSecondaryMenuDD, nestedSecondaryMenuItem);
            nestedSecondaryMenuItem.focus();
          }
        }
      });

      nestedSecondaryMenuList.addEventListener("mouseover", function(event) {
        event.stopPropagation();
        if (window.innerWidth > 979) {
          if (!this.classList.contains("is-toggle")) {
            this.classList.add("is-toggle");
          }
        } 
        if (this.classList.contains("custom-nested-secondary-nav")) {
          nestedSecondaryMenuItem.classList.add("is-hover");
        }
      });

      nestedSecondaryMenuList.addEventListener("mouseleave", function(event) {
        event.stopPropagation();
        if (this.classList.contains("custom-nested-secondary-nav")) {
          nestedSecondaryMenuItem.classList.remove("is-hover");
        }
        this.classList.remove("is-toggle");
      });

      function openSecondaryDD(dropdownElement, buttonElement) {
        var isDropdownOpen = dropdownElement.dataset.isopen;
        if (isDropdownOpen === 'false' || isDropdownOpen === undefined) {
          dropdownElement.dataset.isopen = 'true';
          dropdownElement.parentElement.classList.toggle("is-toggle");
          dropdownElement.previousElementSibling.classList.add('is-hover');
          buttonElement.classList.add('focussed');
          buttonElement.setAttribute('aria-expanded', 'true');
          return true;
        } else {
          closeSecondaryDD(dropdownElement, buttonElement);
        }
      }
    
      function closeSecondaryDD(dropdownElement, buttonElement) {
        var isDropdownOpen = dropdownElement.dataset.isopen;
        if (!!isDropdownOpen && isDropdownOpen === 'true') {
          dropdownElement.dataset.isopen = 'false';
          dropdownElement.parentElement.classList.remove("is-toggle");
          dropdownElement.previousElementSibling.classList.remove('is-hover');
          buttonElement.classList.remove('focussed');
          buttonElement.setAttribute('aria-expanded', 'false');
          return true;
        }
        return false;
      }

      function fnToggleSecondaryMenu(event) {
        event.stopPropagation();
        this.classList.toggle("is-toggle");
        if (!this.classList.contains("is-toggle")) {
          nestedSecondaryMenuItem.classList.remove('is-hover');
        } else {
          nestedSecondaryMenuItem.classList.add('is-hover');
        }
      }

      window.addEventListener('resize', function() {
        nestedSecondaryMenuToggleFn();
      }, false);
    }

    /**
    * Nested Secondary Custom single page scroll menu
    */
    var secNavMenuLambdaTest = document.getElementsByClassName("lt_alternative")[0],
      customScrollToSecLinks = document.querySelectorAll('.custom-scrollto-section > a');
    
    //for Landing page LT vs BS
    if (secNavMenuLambdaTest) {
      var getSignInBtn = document.getElementById('sign_in_link'),
        getCtaBtnMenu = document.getElementById('sec_nav_cta');

      getCtaBtnMenu.classList.add('custom-sec-nav-cta');
      getSignInBtn.innerHTML = "Get Demo";
      getSignInBtn.setAttribute('title', 'Get Demo Sec Header')
    }

    // Custom single page scroll functionality
    if (customScrollToSecLinks.length > 0) {
      for (var i = 0; i < customScrollToSecLinks.length; i++) {
        customScrollToSecLinks[i].addEventListener(
          "click",
          secMenuScrollToSectionFn
        );
      }

      function secMenuScrollToSectionFn(e) {
        e.preventDefault();
        e.stopPropagation();
        removeActiveSectionClass();
        var that = this,
        btn_href = that.getAttribute("href"),
        offsetTop = document.querySelector(btn_href).offsetTop - 60;
        that.classList.add('active-section');
        bsLib.scrollIt(
          offsetTop,
          1000
        );
      }

      function removeActiveSectionClass() {
        for (var i = 0; i < customScrollToSecLinks.length; i++) {
          customScrollToSecLinks[i].classList.remove('active-section');
        }
      }
    }
  };
  init();
})();
 